export const TermsEnglish = () => {
    return (
        <>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                These Terms and Conditions (the “Terms” or this “Agreement”)
                govern the use of the electronic platform, including any website
                or mobile application (the “App”, together with the website, the
                “Site”) for accessing the platform, and any services provided
                through the platform (collectively, the “Platform”) provided by
                SafeTravy Limited (the “Company”, “we”, “us” or “our”). The
                Terms form a binding agreement between the Company and you, as
                an individual user (“you”, “your” or “User”) for your individual
                usage of the App and Platform. By registering for and
                downloading the App and using the Platform, you confirm your
                acceptance of this Agreement and our associated Privacy Policy.
                If you do not agree to these Terms, you must immediately
                uninstall the App and cease using the App and the Platform.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                Securities Disclaimer: No material or any other information that
                may be made available on the Site or Platform shall constitute
                or be construed as a recommendation, endorsement, offer,
                invitation or solicitation to you to make any decision, all made
                decisions are made out of your own will and experience. You
                further understand that none of the information providers,
                including any Third-Party Providers (as defined below) are
                advising you personally concerning the nature, potential, value
                or suitability of any particular security questions regarding
                your travels. Please note that the situation in the world
                changes rapidly, so any information, content, Third-Party
                Content (as defined below) or other material provided on or
                through the Site or Platform may not be complete or current, or
                may be superseded by more current information. You rely on such
                information at your own risk.{' '}
            </p>
            <p style={{ marginBottom: '0in' }}>
                Our Site and Platform are not intended to provide legal,
                insurance, or investment advice, and nothing on the Site or
                Platform should be construed as an offer to you on how to
                organize your travel. All this information is only personalized
                recommendation.{' '}
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                Use of the platform is currently provided free of charge. Users
                may access and utilize the services offered without any payment
                or subscription fee. We reserve the right to introduce premium
                features or modify the pricing structure in the future, but any
                such changes will be communicated in advance. Users experience
                the information given by the platform at their own risk and
                responsibility.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>1. Applicability</b>
            </p>
            <p style={{ marginBottom: '0in' }}>
                1.1. We, SafeTravy Limited (hereinafter “SafeTravy”), offer
                services in the field of IT entertainment These general terms
                and conditions apply to the contractual relationship between
                SafeTravy and the Customer (“Customer” or “You”) with respect to
                all services we provide.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>2. Definitions</b>
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Account</b>
                means the account established by a User that has downloaded the
                App or accessed the Site and registered with the Company to use
                the Site and the Platform.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>App</b>
                means the mobile application provided by the Company to access
                the Platform.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Authorized Individual </b>
                means any person that is authorized to access and use the Site
                (including the App) and Platform on behalf of a User.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Digital Platforms</b> refers to third-party distribution
                platforms where mobile applications or other software programs
                can be accessed or downloaded, including, but not limited to,
                the Apple App Store and Google Play.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Governmental Authority</b> means any nation or government or
                any province or state or any other political subdivision
                thereof, or any entity, authority or body exercising executive,
                legislative, judicial, regulatory or administrative functions of
                or pertaining to government, including any government authority,
                agency, department, board, commission or instrumentality or any
                political subdivision thereof, any court, tribunal or
                arbitrator, and any self-regulatory organization.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Material</b>
                means any offering material, term sheet, research report,
                product or service documentation or any other information
                provided through the Platform.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Personal Information </b>
                refers to information supplied by a User from which the identity
                of such User may be directly or indirectly ascertained.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Privacy Policy</b> means the additional terms and conditions
                governing the collection, use and disclosure of each User’s
                Personal Information, as set out here. Each User must read and
                agree to the Privacy Policy in order to use the App or the Site.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Service Notifications</b> are one-way notifications from the
                Company (which may include security-related notifications) via
                text message or emails and, where applicable, push notifications
                through the Site. These notifications are sent to the User in
                respect of certain information or events relating to an account
                to which an User has access through the Platform.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>User</b>
                means any person that has registered with the Company to use the
                Site and access the Platform and any Authorized Individual
                acting on their behalf.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>User Credentials</b> means the set of user identification,
                password, personal identification number, token and any other
                information or device provided to an User to access the
                Platform.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Company</b>
                (referred to as either "the Company", "We", "Us" or "Our" in
                this Agreement) refers to SAFETRAVY.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Device</b>
                means any device that can access the Service such as a computer,
                a cellphone or a digital tablet.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Service</b>
                refers to all the information, recommendations and notifications
                provided by the website.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Terms and Conditions </b>
                (also referred as "Terms") mean these Terms and Conditions that
                form the entire agreement between You and the Company regarding
                the use of the Service.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Third-party</b>
                Service means any services or content (including data,
                information, products or services) provided by a third-party
                that may be displayed, included or made available by the
                Service.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Website</b>
                refers to SafeTravy, accessible from www.safetravy.com
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Changes</b>
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                We reserve the right at any time to:
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                (a) modify, update or change the terms and conditions of this
                Agreement or our Privacy Policy ;{' '}
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                (b) modify, update, or change the Site and Platform, including
                eliminating or discontinuing any content or feature of the Site
                or Platform (all of the foregoing referred to as “Changes”).
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                We may make such Changes at any time without prior notice. Any
                Changes to this Agreement may be posted on our website or
                notified to you through push notifications through the Site or
                an email to the email address in your Account. For this reason,
                you should check our website regularly, allow the Site to
                receive such push notifications, and keep your email address and
                other contact information up to date in the Account. You accept
                any Changes if you continue to use the Site and Platform after
                such Changes are effected.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Digital Platform Terms</b>
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                The App may be available for download from one or more Digital
                Platforms. Your download, installation, access to or use of the
                App is also bound by the terms and conditions and privacy
                policies of the applicable Digital Platform (the “Digital
                Platform Terms”). If there is any conflict between these Terms
                and the Digital Platform Terms, then these Terms will prevail.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                The App is independent of and is not associated, affiliated,
                sponsored, endorsed or in any way linked to any Digital
                Platform. You and we acknowledge that this Agreement is entered
                into between you and us only, and not with any Digital Platform,
                and we, not the Digital Platform, are solely responsible for the
                App and the content thereof to the extent specified in this
                Agreement.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                You and we acknowledge and agree that the relevant Digital
                Platform, and that Digital Platform’s subsidiaries are
                third-party beneficiaries of these Terms, and that, upon your
                acceptance of these Terms, that Digital Platform will have the
                right (and will be deemed to have accepted the right) to enforce
                these Terms against you as a third-party beneficiary thereof.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Network Device and Carrier Requirements</b>
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                You acknowledge that your agreement with your mobile and
                Internet network provider (the “Network Provider”) will apply to
                your use of the Site. You acknowledge that you may be charged by
                your Network Provider for data services while using certain
                features of the Site or any other third-party charges as may
                arise and you accept sole responsibility for such charges. If
                you are not the bill payer for the mobile/Internet device being
                used to access the Site, you will be assumed to have received
                permission from the bill payer for using the Site. You must also
                ensure that your use of the Site is not in violation of your
                mobile or Internet device agreement or any wireless data service
                agreement.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Eligibility and Registration</b>
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                You must be at least 18 years of age to access and use the Site
                and Platform. You further affirm that you are fully able and
                competent to enter into the terms, conditions, obligations,
                affirmations, representations, and warranties set forth in these
                Terms, and to abide by and comply with these Terms. You must
                register with the Company to use the Site and the Platform; you
                agree to provide complete and accurate information when
                registering to use the Site and the Platform, and to keep that
                information updated.{' '}
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                We have the sole discretion to accept or reject your
                registration with the Platform. Only Users whose registrations
                are approved by us will be our customers.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Acknowledgment</b>
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                These are the Terms and Conditions governing the use of this
                Service and the agreement that operates between You and the
                Company. These Terms and Conditions set out the rights and
                obligations of all users regarding the use of the Service.
            </p>
            <p style={{ marginBottom: '0in' }}>
                Your access to and use of the Service is conditioned on Your
                acceptance of and compliance with these Terms and Conditions.
                These Terms and Conditions apply to all visitors, users and
                others who access or use the Service.
            </p>
            <p style={{ marginBottom: '0in' }}>
                By accessing or using the Service You agree to be bound by these
                Terms and Conditions. If You disagree with any part of these
                Terms and Conditions then You may not access the Service.
            </p>
            <p style={{ marginBottom: '0in' }}>
                You represent that you are over the age of 18. The Company does
                not permit those under 18 to use the Service.
            </p>
            <p style={{ marginBottom: '0in' }}>
                Your access to and use of the Service is also conditioned on
                Your acceptance of and compliance with the Privacy Policy of the
                Company. Our Privacy Policy describes Our policies and
                procedures on the collection, use and disclosure of Your
                personal information when You use the Application or the Website
                and tells You about Your privacy rights and how the law protects
                You. Please read Our Privacy Policy carefully before using Our
                Service.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>User Accounts</b>
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                In order to use the services on the Platform, you must create an
                account with the Platform (the “Account”). The Account may be
                registered by any individual who is over 18 years old.{' '}
            </p>
            <p style={{ marginBottom: '0in' }}>
                When You create an account with Us, You must provide Us
                information that is accurate, complete, and current at all
                times. Failure to do so constitutes a breach of the Terms, which
                may result in immediate termination of Your account on Our
                Service.
            </p>
            <p style={{ marginBottom: '0in' }}>
                You are responsible for safeguarding the password that You use
                to access the Service and for any activities or actions under
                Your password, whether Your password is with Our Service or a
                Third-Party Service.{' '}
            </p>
            <p style={{ marginBottom: '0in' }}>
                You agree not to disclose Your password to any third party. You
                must notify Us immediately upon becoming aware of any breach of
                security or unauthorized use of Your account. You can enter your
                account only from one device.
            </p>
            <p style={{ marginBottom: '0in' }}>
                You may not use as a username the name of another person or
                entity or that is not lawfully available for use, a name or
                trademark that is subject to any rights of another person or
                entity other than You without appropriate authorization, or a
                name that is otherwise offensive, vulgar or obscene.
            </p>
            <p style={{ marginBottom: '0in' }}>
                Each User acknowledges that each set of User Credentials is
                non-transferable and shall only be used by the User to whom it
                is issued. Such User Credentials shall not be disclosed to or
                transfer to any third person without written permission of the
                Company. We will never ask you, for any reason, whether by
                email, regular mail or telephone, to disclose your User
                Credentials. Password inquiries will only be conducted online
                and only after you have signed onto the Platform. We will never
                send you embedded links in an email requesting that you sign
                onto the Platform by clicking such a link. If you receive an
                embedded link by email, claiming to be from us or the Platform,
                you shall not open or click on the link. The email is not from
                us and is likely fraudulent.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Authorized Individuals</b>
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                Each User and Authorized Individual acknowledges that they have
                received and accepted these Terms. When applying for any
                Authorized Individual to receive access to the Platform and an
                Account on their behalf, the User acknowledges and represents
                that the Authorized Individual is duly authorized to (i) access
                and use the Platform on the User’s behalf and, if applicable, to
                exercise the same powers conferred by the User upon the
                Authorized Individual in accordance with any underlying power of
                attorney to the same extent as is technically feasible and that
                services offered under the Platform are analogous to services
                that the User may utilize through other channels; (ii) accept
                any Changes to these Terms on the User’s behalf.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                Each User shall procure that each Authorized Individual acting
                on their behalf is informed of and agrees to and complies with
                these Terms and, as applicable, the Third-Party Services
                Provider Terms. You shall be fully liable for all acts or
                omissions or non-compliance of your designated Authorized
                Individual in the access and use of the Platform.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                You represent, undertake and confirm that you have procured the
                consent of your Authorized Individuals to the collection, use,
                transfer, disclosure and processing of the Personal Information
                of such Authorized Individuals in accordance with these Terms
                and the Privacy Policy.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                You understand and agree that the information and services
                provided by the Platform are not provided to, and may not be
                used by or for the benefit of, any individual or entity in any
                jurisdiction where the provision or use thereof would be
                contrary to any applicable law, or where we are not authorized
                to provide such Platform or information and services.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Intellectual Property</b>
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                All title, ownership rights and intellectual property rights in
                or relating to the Site and Platform, any information
                transmitted by, to or over the Platform and information
                regarding use of the Platform will remain with the Company or
                its licensors. Nothing on the Platform will be construed as
                conferring on any User any license, save as expressly set out
                herein, of any of the Company’s or any third party’s title,
                ownership rights and/or intellectual property rights, whether by
                estoppel, implication or otherwise.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                The Platform and App may provide you access to content,
                information, quote, videos, photos or other materials (the
                “Third-Party Content”) supplied by certain third parties (the
                “Third-Party Content Providers”). The Company does not endorse
                or recommend, and is not responsible for verifying the accuracy,
                validity or completeness of any Third-Party Content provided
                through the Site or Platform. Your use or reliance on such
                Third-Party Content is at your sole risk. All title, ownership
                rights and intellectual property rights in or relating to the
                Third-Party Content will remain with the applicable Third-Party
                Content Provider. Nothing on the Platform will be construed as
                conferring on any User any license, save as expressly set out
                herein, of any Third-Party Content Provider’s title, ownership
                rights and/or intellectual property rights, whether by estoppel,
                implication or otherwise.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                Provided you are in compliance with these Terms, you can
                download and access the Site on a single mobile device and
                access the Platform using properly issued User Credentials. All
                other rights in the Site are reserved by the Company. In the
                event of your breach of these Terms, we will be entitled to
                terminate your use and access to the Site and Platform
                immediately.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>You agree not to:</p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                (a) modify, adapt, reproduce, translate or create derivative
                works of the Site or Platform, or any data or content (including
                the Third-Party Content) provided through the Site or Platform,
                or any portion thereof, or attempt to reverse engineer,
                decompile, disassemble or otherwise attempt to discover the
                source code of the Site or Platform;
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                (b) remove any copyright notice, trademark, legend, logo or
                product identification from the Site or Platform;
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                (c) misrepresent the other sites as the Company’s Site by
                co-opting the visual “look and feel” of or text from the
                Company’s Site or otherwise violate the Company’s intellectual
                property rights, including, without limitation, “scraping” text
                or images from the Company’s Site or the Company managed banners
                and/or text links, search marketing or all other online and
                offline campaigns,
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                (d) edit, modify, filter, truncate or change the order of the
                information contained in any part of the Company’s Sites, or
                remove, obscure, or minimize any part of the Company’s Site in
                any way without authorization of the Company; or
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                (e) make any commercial use of the Site or Platform or the
                Company’s logo, trademark or brand name in any way.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                Each User authorizes the Company to use any information or
                content provided by the User or processed in connection with the
                use of the Site and Platform (e.g. Personal Information,
                geographic information, device information) in the context and
                for the purpose of providing services or products on the
                Platform and the secure use of the Site and the Platform.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Provision of Material and Information</b>
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                You acknowledge that neither the Company nor the Platform is
                your travel adviser or fiduciary. You further acknowledge that
                none of the Materials we provide or made available on the
                Platform constitutes our recommendation or solicitation that you
                enter into any particular decision during your travel.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                You acknowledge that we have no duty or obligation to verify,
                correct, complete or update any Material displayed on the
                Platform. Materials, including without limitation, news and
                research, may be prepared by information providers that are
                independent of us. We do not warrant that the Material will be
                accurate, complete or refreshed in a timely manner. You should
                conduct further research and analysis or consult a travel
                advisor before making decisions. Any use of or reliance on
                materials by you is at your own risk.{' '}
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Service and Other Notifications</b>
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                You agree to accept notifications regarding the App, Platform,
                your Account and Terms through Service Notifications. You agree
                that such Service Notifications shall constitute effective
                notice in lieu of written, mailed or other forms of notice
                required by applicable law.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                It is your sole responsibility to monitor the applicable email
                account without further reminders or repeat notifications from
                the Company. You shall immediately report any unauthorized use
                or access of the Platform.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                You release the Company from any liability for losses or damages
                resulting from the use of the Service Notifications to the
                extent permitted by law. The Company provides no warranty or
                accepts no liability that the information provided through
                Service Notifications is up-to-date, correct or complete.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Personal Information</b>
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                As part of the Platform, Personal Information of the User may be
                collected, used, transferred, disclosed or otherwise processed
                by the Company in accordance with the Privacy Policy. You should
                read the Privacy Policy carefully before registering for and
                using the Site and Platform. You consent to the collection, use
                and disclosure of your Personal Information in accordance with
                these Terms and the Privacy Policy, including without
                limitation, disclosure to the Third-Party Services Provider for
                purposes of providing services in regards to the Account.{' '}
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                You agree to provide true, accurate, current and complete
                Personal Information. You further agree to maintain and promptly
                update the Personal Information to keep it true, accurate,
                current and complete at all times during the term of this
                Agreement.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                You must promptly inform us of all changes, including, but not
                limited to, changes in the Personal Information in connection
                with the Platform. If you provide any information that is
                untrue, inaccurate, not current or incomplete, or if we or any
                of our authorized agents have reasonable grounds to suspect that
                such information is untrue, inaccurate, not current or
                incomplete, we have the right to suspend or terminate the
                Account and refuse any and all current or future use of the
                Platform and Site by you, as well as subject you to civil
                liability or refer you to the appropriate law enforcement
                authorities for criminal prosecution. We shall not be liable to
                make any compensation, monetary or otherwise, following such
                suspension, termination or inability for you to use the Platform
                or the Site.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                Please note that we may collect information using tracking
                technologies regarding your device, such as IP address, network
                provider, mobile carrier, mobile browser type, timestamp, time
                zone, information about the speed, bearing, orientation, and
                altitude of a device, or other device-identifying information.
                The User consents to such use of tracking technologies and
                acknowledges that the information obtained, including Personal
                Information, may be matched to public or private information
                accessible to the Company or any Third-Party Services Provider.
                The User also consents to such information being shared with the
                Company’s and Third-Party Services Provider’s service providers
                for the purposes of providing and maintaining the tracking
                technologies and related services. We may also collect precise
                geolocation data from or about your device, which may be
                expressed by latitude-longitude coordinates obtained through GPS
                tools, WiFi data, cell tower triangulation or other techniques.
                Our use of such information is described in our Privacy Policy.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Cookies and how do we use them</b>
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                Cookies are text files placed on your computer to collect
                standard Internet log information and visitor behaviour
                information. When you visit our websites, we may collect
                information from you automatically through cookies or similar
                technology SafeTravy uses cookies in a range of ways to improve
                your experience on our website and other digital services.{' '}
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                There are a number of different types of cookies, however, our
                website uses:
            </p>
            <ul>
                <li>
                    <p style={{ marginBottom: '0in' }}>
                        Account and login information
                    </p>
                </li>
                <li>
                    <p style={{ marginBottom: '0in' }}>Surveys and forms</p>
                </li>
                <li>
                    <p style={{ marginBottom: '0in' }}>Site preferences</p>
                </li>
                <li>
                    <p style={{ marginBottom: '0in' }}>
                        Functionality – SafeTravy uses these cookies so that we
                        recognize you on our website and remember your
                        previously selected preferences. These could include
                        what language you prefer and location you are in. A mix
                        of first-party and third-party cookies are used.
                    </p>
                </li>
                <li>
                    <p style={{ marginBottom: '0in' }}>
                        Advertising – SafeTravy uses these cookies to collect
                        information about your visit to our website, the content
                        you viewed, the links you followed and information about
                        your browser, device, and your IP address. SafeTravy
                        sometimes shares some limited aspects of this data with
                        third parties for advertising purposes. We may also
                        share online data collected through cookies with our
                        advertising partners. This means that when you visit
                        another website, you may be shown advertising based on
                        your browsing patterns on our website.
                    </p>
                </li>
            </ul>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                You can set your browser to refuse all or some browser cookies
                or to alert you when websites set or access cookies. If you
                disable or refuse cookies, please note that some parts of our
                websites, products and services may become inaccessible or not
                function properly.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Disclaimer and Risks of Use of Platform</b>
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                The Platform and Site, including all content (including
                Third-Party Content), features and any related services are
                provided on an “As Is” and “As Available” basis at the User’s
                sole risk and without any representations or warranties. We do
                not guarantee that all or any part of the Platform or the App
                will be available or accessible by the User at all times.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                The use of the Platform, due to the download, installation or
                use of the Site and the associated reference points with third
                parties (for example, distribution platform providers, network
                providers, device manufacturers) involves risks, in particular:
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                (a) disclosure of your Personal Information or other information
                and the existence of your relationship with the Third-Party
                Services Provider to third parties;
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                (b) system outages, security-related restrictions and
                unauthorized removal of use restrictions on the end device, and
                other disturbances which may make use impossible; and
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                (c) misuse due to manipulation by malware or unauthorized use,
                including in the event the User’s device used to access the Site
                or the Platform is lost or stolen.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                We are entitled to block or disable the use of the Site on end
                devices if the security features devised by the operating system
                or manufacturer of such device on which the Site is installed
                have been modified at any time (for example, a device that has
                been “jailbroken”). Accordingly, we do not guarantee the
                functioning and operation of the App on end devices which have
                been modified in this way or on older end devices that no longer
                meet the technical requirements for the use of the Site or
                access to the Platform.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                ALL WARRANTIES, CONDITIONS OR TERMS (WHETHER EXPRESS, IMPLIED,
                STATUTORY OR OTHERWISE) INCLUDING WITHOUT LIMITATION RELATING TO
                QUALITY, MERCHANTABILITY, FITNESS FOR PURPOSE, OR UNINTERRUPTED,
                ERROR-FREE ACCESS ARE EXPRESSLY EXCLUDED FOR THE SITE AND
                PLATFORM TO THE FULLEST EXTENT PERMITTED BY LAW.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                No representation or warranty, express or implied, can be given
                as to the accuracy or completeness of the information provided
                in the Platform.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                Each User acknowledges and accepts the risks that may arise from
                the travel experience. We may also use servers and other
                computer hardware situated in any jurisdiction worldwide for the
                provision of any portion of the Platform.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                We exclude any and all liability for loss or damage caused by
                transmission errors, technical faults, breakdowns, business
                interruptions or illegal interventions into transmission
                networks, IT systems/computers of the User or of any third party
                (including systems in the public domain).
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Termination</b>
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                We may terminate or suspend Your Account immediately, without
                prior notice or liability, for any reason whatsoever, including
                without limitation if You breach these Terms and Conditions.
            </p>
            <p style={{ marginBottom: '0in' }}>
                Upon termination, Your right to use the Service will cease
                immediately. If You wish to terminate Your Account, You may
                simply discontinue using the Service.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Release</b>
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                To the maximum extent permitted by applicable law, you hereby
                discharge, acquit, and otherwise release us, our parent company,
                affiliates and subsidiaries and each of their respective
                officers, directors, shareholders, members, partners, attorneys,
                employees, independent contractors, telecommunication providers,
                and agents (collectively, the “Indemnified Parties”), from any
                and all allegations, counts, charges, debts, causes of action,
                claims and losses, relating in any way to the use of, or
                activities relating to the use of the Site, Platform, any
                Account and any services or Third-Party Content provided through
                the Site, Platform or any Account, including, but not limited
                to, claims relating to the following: negligence, gross
                negligence, intentional interference with contract or
                advantageous business relationship, defamation, privacy,
                publicity, misrepresentation, false identities, fraudulent acts
                by others, invasion of privacy, release of Personal Information,
                unavailability of the Site, the Platform, Third-Party Content or
                any Account, their functions and any other technical failure
                that may result in inaccessibility to the Site, the Platform,
                Third-Party Content or any Account, or any claim based on
                vicarious liability for torts committed by you encountered or
                transacted with through the Site, Platform, Third-Party Content
                and any Account, including, but not limited to, fraud, computer
                hacking, theft or misuse of Personal Information, assault,
                battery, stalking, rape, cheating, perjury, manslaughter, or
                murder. The above list is intended to be illustrative only, and
                not exhaustive of the types or categories of claims released by
                us. This release is intended by the parties to be interpreted
                broadly in favor of us, and thus any ambiguity shall be
                interpreted in a manner providing release of the broadest
                claims. This release is intended to be a full release of claims,
                and the parties acknowledge the legally binding nature of this
                provision, and the nature of the rights given up in connection
                therewith.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Limitation of Liability</b>
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                SafeTravy is not liable for any information which is available
                via and/or integrated with the SafeTravy Products. Consequently,
                SafeTravy cannot be held liable for the correctness,
                completeness, quality, lawfulness and reliability of the
                information or for the results which are achieved by means of
                such information.{' '}
            </p>
            <p style={{ marginBottom: '0in' }}>
                The SafeTravy Services does not constitute tools to be used for
                and support risk management and risk assessment. SafeTravy is
                unable to warrant that all information and updates are complete,
                adequate and error-free. Users should always evaluate output and
                data from the service on an individual basis. SafeTravy aims to
                reduce risk for the users but shall in no way be responsible for
                the safety and security of the users and SafeTravy assumes no
                liability for losses, bodily injury or death of users.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                UNDER NO CIRCUMSTANCES AND UNDER NO THEORY OF LAW (TORT,
                CONTRACT, STRICT LIABILITY OR OTHERWISE), SHALL WE OR ANY OF THE
                INDEMNITEES BE LIABLE TO YOU OR ANY OTHER PERSON FOR ANY DAMAGES
                ARISING FROM THE USE OR MISUSE OF, OR INABILITY TO USE, THE
                PLATFORM, THE SITE, THIRD-PARTY CONTENT OR ANY ACCOUNT,
                REGARDLESS OF WHETHER SUCH DAMAGES ARE DIRECT, INDIRECT,
                SPECIAL, INCIDENTAL OR CONSEQUENTIAL DAMAGES OF ANY CHARACTER,
                LOSS OF INFORMATION, BUSINESS INTERRUPTION OR LOST PROFITS, LOST
                SAVINGS, OR LOSS OF DATA, OR LIABILITIES UNDER ANY CONTRACT,
                NEGLIGENCE, STRICT LIABILITY, OR OTHER THEORY ARISING OUT OF OR
                RELATING IN ANY MANNER TO THE SITE, THE PLATFORM, THIRD-PARTY
                CONTENT OR ANY ACCOUNT OR FOR ANY CLAIM OR DEMAND BY ANY THIRD
                PARTY, EVEN IF WE KNEW OR HAD REASON TO KNOW OF THE POSSIBILITY
                OF SUCH DAMAGES, CLAIM OR DEMAND IF THE FOREGOING DISCLAIMER AND
                WAIVER OF LIABILITY SHOULD BE DEEMED INVALID OR INEFFECTIVE.
                SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF
                CERTAIN WARRANTIES AND/OR LIABILITIES, SO CERTAIN OF THE ABOVE
                LIMITATIONS OR EXCLUSIONS MAY NOT APPLY TO YOU.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                We will not be liable for our failure to perform any obligations
                under these Terms due to events beyond our control, and the time
                provided for performing such obligations shall be extended by a
                period of time equal to the duration of such events. Events
                beyond our control include, without limitation, acts of God,
                war, riot, arson, embargoes, civil commotion, strikes, labor
                disputes, equipment failures, bank failures, virtual currency
                market collapse or fluctuations, strikes, fire, flood,
                earthquake, hurricanes, tropical storms or other natural
                disaster or casualty, shortages of labor or material, shortage
                of transportation, facilities, fuel, energy, government
                regulation or restriction, acts of civil or military authority
                or terrorism, fiber cuts, weather conditions, breaches or
                failures to perform by third parties, technical problems,
                including hardware and software crashes and other malfunctions,
                failure of the telecommunications or information services
                infrastructure, hacking, SPAM or failure of any computer, server
                or software disruptions on account of or caused by vandalism,
                theft, phone service outages, power outage, Internet
                disruptions, viruses, and mechanical, power or communications
                failures.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Changes to These Terms and Conditions</b>
            </p>
            <p style={{ marginBottom: '0in' }}>
                We reserve the right, at Our sole discretion, to modify or
                replace these Terms at any time. If a revision is material We
                will make reasonable efforts to provide at least 30 days' notice
                prior to any new terms taking effect. What constitutes a
                material change will be determined at Our sole discretion.
            </p>
            <p style={{ marginBottom: '0in' }}>
                By continuing to access or use Our Service after those revisions
                become effective, You agree to be bound by the revised terms. If
                You do not agree to the new terms, in whole or in part, please
                stop using the website and the Service.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>General</b>
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                These Terms, including the Privacy Policy and other policies
                incorporated herein, constitute the entire and only agreement
                between you and the Company with respect to the subject matter
                of these Terms, and supersede any and all prior or
                contemporaneous agreements, representations, warranties and
                understandings, written or oral, with respect to the subject
                matter of these Terms. If any provision of these Terms is found
                to be unlawful, void or for any reason unenforceable, then that
                provision shall be deemed severable from these Terms and shall
                not affect the validity and enforceability of any remaining
                provisions. These Terms may not be changed, waived or modified
                except by the Company as provided herein. Neither these Terms
                nor any right, obligation or remedy hereunder is assignable,
                transferable, delegable or sublicensable by you except with our
                prior written consent, and any attempted assignment, transfer,
                delegation or sublicense shall be null and void. No waiver by
                any party of any breach or default hereunder shall be deemed to
                be a waiver of any preceding or subsequent breach or default.
                Any heading, caption or section title contained in these Terms
                is inserted only as a matter of convenience and in no way
                defines or explains any section or provision hereof.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Governing Law and Dispute Resolution</b>
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                All disputes, disagreements or claims arising under this
                agreement or in connection with it, including those relating to
                its conclusion, interpretation, execution, violation,
                termination or invalidity, shall be resolved by the
                International Commercial Arbitration Court at the Ukrainian
                Chamber of Commerce and Industry in accordance with its
                Regulations.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                The law governing this agreement is the substantive law of
                Gibraltar.{' '}
            </p>
            <p style={{ marginBottom: '0in' }}>
                The arbitration court consists of a sole arbitrator. The
                location of the meeting of the Arbitration Court is the city of
                Kyiv, Ukraine. The language of the arbitration proceedings is
                English or Ukrainian.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Contact Us</b>
            </p>
            <p style={{ marginBottom: '0in' }}>
                If you have any questions about these Terms and Conditions, You
                can contact us by email{' '}
                <a href='mailto:support@safetravy.com'>
                    <u style={{ color: '#1155cc' }}>support@safetravy.com</u>
                </a>
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
        </>
    )
}
